<!--
  - Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
  -->

<template>
  <div class="layout">
    <slot name="header"></slot>
    <!-- default header -->
    <page-header v-if="!$slots.header"></page-header>
    <div class="page-content-wrapper">
      <slot name="content"></slot>
    </div>
    <slot name="footer"></slot>
    <!-- default footer -->
    <page-footer v-if="!$slots.footer"></page-footer>
  </div>
</template>
<script>
import PageHeader from "./../../components/page-header.vue";
import PageFooter from "./../../components/page-footer.vue";

export default {
  components: {
    PageHeader,
    PageFooter
  },
  mounted() {
    if (this.$route.meta.scrollToTop) {
      window.scrollTo(0, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f6;
}

.page-content-wrapper {
  flex-grow: 1;
}
</style>
